import { useState } from "react";

export const faqs = [
  {
    question: "Mon volet électrique ne répond plus, pourquoi ?",
    answer: "Un volet électrique qui ne répond plus peut avoir plusieurs causes. La plus fréquente est une déprogrammation de la télécommande ou une perte de synchronisation avec le récepteur radio. Vérifiez d'abord que les piles de la télécommande sont neuves. Si le problème persiste, il peut s'agir d'une coupure d'alimentation électrique, d'un disjoncteur déclenché, ou d'un défaut de la platine de commande. Notre technicien teste chaque maillon de la chaîne pour identifier l'origine exacte et réparer le composant concerné.",
  },
  {
    question: "Est-ce le moteur ou la commande qui est en panne ?",
    answer: "Pour différencier une panne de moteur d'une panne de commande, le technicien effectue une série de tests ciblés. Il vérifie d'abord l'alimentation électrique aux bornes du moteur : si la tension est présente mais le moteur ne tourne pas, le problème vient du moteur. Si la tension est absente, le défaut se situe en amont, dans la commande, le câblage ou l'interrupteur. Pour les volets radio, il teste la réception du signal avec un appareil de diagnostic. Cette méthode permet de cibler l'élément exact à réparer, sans remplacer inutilement des composants fonctionnels.",
  },
  {
    question: "Quel est le délai d'intervention pour un volet électrique en panne ?",
    answer: "Pour les interventions en urgence, nous intervenons le jour même ou le lendemain dans la zone de Strasbourg et du Bas-Rhin. Pour les rendez-vous non urgents, nous proposons des créneaux dans les 48 heures suivant votre appel. La plupart des réparations électriques sont réalisées en une seule visite, car nos techniciens disposent d'un stock de pièces détachées pour les principales marques de motorisation. Si une pièce spécifique doit être commandée, nous vous indiquons le délai d'approvisionnement et fixons un second rendez-vous pour l'installation.",
  },
  {
    question: "Quel est le prix d'une réparation de volet électrique ?",
    answer: "Le prix d'une réparation de volet électrique dépend de la nature de la panne. Un simple réglage de fin de course, une reprogrammation de télécommande ou un remplacement de condensateur représente un coût modeste. Un remplacement de moteur tubulaire ou de platine de commande est plus conséquent. Nous établissons un diagnostic gratuit sur place et vous proposons un devis transparent avant toute intervention. Vous ne payez que si vous acceptez le devis, et vous connaissez le prix exact avant que les travaux ne commencent.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Questions fréquentes sur la réparation de volet électrique
        </h2>
        <div className="space-y-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-brand-light border border-brand-border rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
              >
                <span className="text-brand-blue font-semibold text-base md:text-lg pr-4">
                  {item.question}
                </span>
                <span className="w-8 h-8 flex items-center justify-center text-brand-cyan flex-shrink-0">
                  <i
                    className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-xl`}
                  ></i>
                </span>
              </button>
              {open === i && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-brand-text leading-relaxed text-sm md:text-base">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}